"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserGroupRequest {
    constructor(name = '', key = '', permissions = [] //IRIs
    ) {
        this.name = name;
        this.key = key;
        this.permissions = permissions;
    }
}
exports.default = UserGroupRequest;
